import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/snail/team/index', method: 'GET', params }, { interceptResultCode: false })
}

// 抽奖
export const lotteryDataAPI = (params) => {
  return axios({ url: '/snail/team/lottery', method: 'POST', params }, { interceptResultCode: false })
}

// 任务
export const taskDataAPI = (params) => {
  return axios({ url: '/snail/team/task', method: 'POST', params }, { interceptResultCode: false })
}

// 彩蛋
export const eggRewardDataAPI = (params) => {
  return axios({ url: '/snail/team/reward', method: 'POST', params }, { interceptResultCode: false })
}

// 帮助初始化
export const onHelpGetInitDataAPI = (params) => {
  return axios({ url: '/snail/team/help', method: 'GET', params }, { interceptResultCode: false })
}

// 加入队伍
export const joinTeamDataAPI = (params) => {
  return axios({ url: '/snail/team/entry', method: 'POST', params }, { interceptResultCode: false })
}

// 领取组队奖励
export const teamInviteDataAPI = (params) => {
  return axios({ url: '/snail/team/invite', method: 'POST', params }, { interceptResultCode: false })
}


// WEBPACK FOOTER //
// ./src/pages/snail/hlw/api.js